
export const CLEAR_MEASURE_LIST = 'measurement/CLEAR_MEASURE_LIST';
export const SET_MEASURE_VALUES = 'measurement/SET_MEASURE_VALUES';
export const SET_MEASURE_TOOL = 'measurement/SET_MEASURE_TOOL';
export const SET_MEASURE_IN_LIST = 'measurement/SET_MEASURE_IN_LIST';

export default function getActions(dispatch) {
    return {
        clearMeasureList: () => dispatch({
            type: CLEAR_MEASURE_LIST
        }),
        setMeasureInList: (measure) => dispatch({
            type: SET_MEASURE_IN_LIST,
            measure
        }),
        setMeasureValues: (values) => dispatch({
            type: SET_MEASURE_VALUES,
            values
        }),
        setMeasureTool: (tool) => dispatch({
            type: SET_MEASURE_TOOL,
            tool
        })
    };
}
